import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/core/service/auth.service';
import { CallApiService } from 'src/app/core/service/call-api.service';
import { GlobalService } from 'src/services/global.service';
import { HttpHeaders } from '@angular/common/http';



@Injectable({
  providedIn: 'root'
})
export class PatientService {

  data = new FormData();
  constructor(
    private callAPI: CallApiService,
    private global: GlobalService,
    private router: Router,
    private authService: AuthService,
    private translate: TranslateService,
    private http: HttpClient
  ) { }

  httpOptions = {
    headers: new HttpHeaders({
      'Authorization': `Bearer ${localStorage.getItem('authentication_token')}`,
      'Accept-Language': localStorage.getItem('lang') ? localStorage.getItem('lang')! : 'en'
    })
  }


  // Get Profile
  getProfile(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/profile', data, this.httpOptions)
  }
  // Update Profile
  updateProfile(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    return this.callAPI._postAPI('/patient/profile-update', data, this.httpOptions)
  }
  // List Transaction history API
  transaction(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/balance-history', data, this.httpOptions)
  }
  // Current balance API
  current_balance(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/current-balance', data, this.httpOptions)
  }
  //Withdrwal History
  withdrawal_transaction_history(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append("language", this.translate.currentLang);
    return this.callAPI._postAPI("/patient/withdrawal-transactions", data, this.httpOptions);
  }
  //Withdrwal Request
  withdrawal_request(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append("language", this.translate.currentLang);
    return this.callAPI._postAPI("/patient/send-withdrawal-request", data, this.httpOptions);
  }
  //  Favorite doctor List
  favorite_doctors_list(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('role', 'doctor');
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/favorite-doctors-list', data, this.httpOptions)
  }
  // Doctor List API
  doctors_list(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/search-doctor', data, this.httpOptions)
  }
  // Doctor Add To Favorite List
  add_favorite_doctor(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('role', "doctor");
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/mark-doctor-favorite', data, this.httpOptions)
  }
  // Doctor remove as favorite
  remove_favorite_doctor(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('role', "doctor");
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/remove-doctor-favorite', data, this.httpOptions)
  }

  //  Favorite Hospital List
  favorite_hospitals_list(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('role', 'hospital');
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/favorite-hospitals-list', data, this.httpOptions)
  }
  // Add To Favorite hospital
  add_favorite_hospital(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('role', "hospital");
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/mark-hospital-favorite', data, this.httpOptions)
  }
  // Hospital remove to favorite list
  remove_favorite_hospital(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('role', "hospital");
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/remove-hospital-favorite', data, this.httpOptions)
  }
  // ==============================================================================================

  // Doctor Detail API
  doctors_details(data) {
    // data.append('doctor_id', this.authService.currentUserValue.id);
    data.append('language', this.translate.currentLang);
    // data.append('page_no', "1");
    return this.callAPI._postAPI('/doctor/profile', data, this.httpOptions)
  }
  // Doctor Appointment slot Detail API
  appointment_slot(data) {
    data.append('language', this.translate.currentLang);
    data.append('patient_id', this.authService.currentUserValue.id);
    return this.callAPI._postAPI('/patient/get-appointment-slot', data, this.httpOptions)
  }
  // ==============================================================================================

  // Hospital Detail API
  hospitals_details(data) {
    data.append('language', this.translate.currentLang);
    data.append('role', "doctor");
    return this.callAPI._postAPI('/hospital/profile', data, this.httpOptions)
  }
  // Hospital List API
  hospital_list(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/hospital-search', data, this.httpOptions)
  }
  // Hospital Departmet List API
  hospital_department_doctor_list(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/department-doctor-list', data, this.httpOptions)
  }
  // Create Appointment List API
  patient_create_appointment(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/create-appointment', data, this.httpOptions)
  }
  // Validate Appointment Slot API
  validate_appointment_slot(data) {
    data.append('user_id', this.authService.currentUserValue.id);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/doctor/validate-appointment-slot-availability', data, this.httpOptions)
  }
  // ======================================================================================
  // Upcoming Appointment List
  lis_of_upcoming_appointment(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/upcoming-appointments', data, this.httpOptions)
  }
  // Past Appointment List
  lis_of_past_appointment(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/past-appointments', data, this.httpOptions)
  }
  // Appointment Detail
  doctor_appointment_details(data) {
    // data.append('appointment_id', this.authService.currentUserValue.id);
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/doctor/appointment-detail', data, this.httpOptions)
  }
  // Chat List Api
  appointment_chat_list(data) {
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/appointment-chat', data, this.httpOptions)
  }
  // Send Chat List Api
  send_doctor_chat_appointment(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('language', this.translate.currentLang);
    // data.append('page_no',"1");
    return this.callAPI._postAPI('/patient/send-chat', data, this.httpOptions)
  }
  // ======================================================================================
  //  Favorite doctor List
  doctors_service(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/doctor/get-doctor-services', data, this.httpOptions)
  }
  // ======================================================================================
  // Medical Strore List API
  medicalstore_list(data) {
    data.append('user_id', this.authService.currentUserValue.id);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/medical-store-list', data, this.httpOptions)
  }
  // Pending Medical Strore List API
  pending_medicalstore_list(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/get-pending-medical-store-list', data, this.httpOptions)
  }
  // Request Prescription List API
  request_prescription_list(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/received-quotations', data, this.httpOptions)
  }
  // ======================================================================================
  // Medical-List Category API
  medicinecategory_list(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/doctor/get-store-medicine-categories', data, this.httpOptions)
  }
  // ======================================================================================
  // Medical-List Sub-Category API
  medicinesubcategory_list(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/doctor/get-medicine-sub-categories', data, this.httpOptions)
  }
  // ======================================================================================
  // Get All Medicine list from medical store
  getAllMedicinesList(data) {
    data.append('user_id', this.authService.currentUserValue.id);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/get-medicine-list', data, this.httpOptions)
  }
  getAllMedicinesDetails(data) {
    data.append('user_id', this.authService.currentUserValue.id);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/get-medicine-info', data, this.httpOptions)
  }
  //======================================================================================
  // Get All Medicine list from Cart
  get_Cart_Details(data) {
    data.append('user_id', this.authService.currentUserValue.id);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/medicine-list-in-cart', data, this.httpOptions)
  }
  //======================================================================================
  //Current balance
  current_money(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/current-balance', data, this.httpOptions)
  }
  //Transaction History
  transaction_history(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/wallet-transactions', data, this.httpOptions)
  }
  // Add Money to wallet
  add_money_to_wallet(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/add-to-wallet', data, this.httpOptions)
  }
  // Add banner List
  GetBannerList(data) {
    data.append('user_id', this.authService.currentUserValue.id);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/get-all-active-banners', data, this.httpOptions)
  }
  // My Address List API
  my_address_list(data) {
    data.append('user_id', this.authService.currentUserValue.id);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/get-all-addresses', data, this.httpOptions)
  }
  // Add My Address
  add_address(data) {
    data.append('user_id', this.authService.currentUserValue.id);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/add-new-address', data, this.httpOptions)
  }
  // Get Address by ID
  get_address_by_id(data) {
    data.append('user_id', this.authService.currentUserValue.id);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/get-address', data, this.httpOptions)
  }
  // Edit My Address
  edit_address(data) {
    data.append('user_id', this.authService.currentUserValue.id);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/update-address', data, this.httpOptions)
  }
  // Delete My Address
  delete_address(data) {
    data.append('user_id', this.authService.currentUserValue.id);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/delete-address', data, this.httpOptions)
  }
  // Set as default Address
  set_as_address(data) {
    data.append('user_id', this.authService.currentUserValue.id);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/make-default', data, this.httpOptions)
  }
  // Get default Address
  get_default_address(data) {
    data.append('user_id', this.authService.currentUserValue.id);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/get-default-address', data, this.httpOptions)
  }
  // Edit My Address
  addFeedback(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/send-review-rating', data, this.httpOptions)
  }
  // View Prescription
  viewPrescription(data) {
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/doctor/get-prescription', data, this.httpOptions)
  }
  // View Patient Prescription
  // viewPrescription1(data) {
  //   data.append('patient_id', this.authService.currentUserValue.id);
  // 	data.append('language', this.translate.currentLang);
  // 	return this.callAPI._postAPI('/doctor/get-prescription', data)
  // }
  // download Prescription
  downloadPrescription(data) {
    data.append('login_id', this.authService.currentUserValue.id);
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/download-appointments-invoice', data, this.httpOptions)
  }
  // // download Patient Prescription
  // downloadPrescription1(data) {
  //   data.append('patient_id', this.authService.currentUserValue.id);
  // 	data.append('language', this.translate.currentLang);
  // 	return this.callAPI._postAPI('/patient/get-prescription', data)
  // }
  // Set Security PIN Prescription
  setSecurityPIN(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI1('/patient/set-security-pin-prescription', data, this.httpOptions)
  }
  // Send Request Quotaion
  request_quotation(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/send-prescription-to-medical-store', data, this.httpOptions)
  }
  // Validate Appointment Schedule
  checkAppointmentSchedule(data) {
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/doctor/validate-appointment-schedule', data, this.httpOptions)
  }
  // Cancel Appointment
  cancelAppointment(data) {
    data.append('user_id', this.authService.currentUserValue.id);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/doctor/cancel-appointment', data, this.httpOptions)
  }
  // // Appointment Detail
  generateSignature(data) {
    data.append('user_id', this.authService.currentUserValue.id);
    data.append('language', this.translate.currentLang);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    return this.callAPI._postAPI('/patient/generate-signature', data, this.httpOptions)
  }
  // Appointment Detail
  // generateSignature(data) {
  //   data.append('user_id', this.authService.currentUserValue.id);
  //   data.append('language', this.translate.currentLang);
  //   data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
  //   return this.callAPI._postAPI('/room-access-token', data, this.httpOptions)
  // }
  // Check Wallet Balance
  check_wallet_balance(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/current-balance', data, this.httpOptions)
  }
  // Wallet Payment
  varify_appointment_payment(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/verify-appointment-payment', data, this.httpOptions)
  }
  // Paypal Payment
  varify_appointment_payment_by_paypal(data) {
    data.append('user_id', this.authService.currentUserValue.id);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/paypal/create', data, this.httpOptions)
  }

  // Wallet Payment
  varify_order_payment(data) {
    data.append('customer_id', this.authService.currentUserValue.id);
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/verifyMedicineOrderPayment', data, this.httpOptions)
  }

  // Store Category List
  store_category_list(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/get-store-medicine-categories', data, this.httpOptions)
  }
  // Store Sub Category List
  store_sub_category_list(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/get-medicine-sub-categories', data, this.httpOptions)
  }
  // Medicine Add To Favorite List
  add_favorite_medicine(data) {
    data.append('favorite_by', this.authService.currentUserValue.id);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/mark-medicine-as-favorite', data, this.httpOptions)
  }
  // Medicine remove as favorite
  remove_favorite_medicine(data) {
    data.append('favorite_by', this.authService.currentUserValue.id);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/remove-favorite-medicine', data, this.httpOptions)
  }
  //  Favorite Medicines List
  favorite_medicines_list(data) {
    data.append('favorite_by', this.authService.currentUserValue.id);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/get-favorite-medicine-list', data, this.httpOptions)
  }
  getMedicineRatingReviews(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/medicine-rating-reviews', data, this.httpOptions)
  }
  addMedicineToCart(data) {
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    data.append('language', this.translate.currentLang);
    data.append('added_by', this.authService.currentUserValue.id);
    return this.callAPI._postAPI('/patient/add-medicine-to-cart', data, this.httpOptions)
  }
  // // Add banner List
  // GetAllMedicalStore(data) {
  // 	data.append('user_id', this.authService.currentUserValue.id);
  // 	data.append('user_role', this.authService.currentUserValue.role.toLowerCase());
  // 	data.append('language', this.translate.currentLang);
  // 	return this.callAPI._postAPI('/patient/medical-store-list', data)
  // }

  // Contact Us API
  contact_us(data) {
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/admin/send-support-email', data, this.httpOptions)
  }

  // Term & Condition
  terms_and_condition(data) {
    data.append("language", this.translate.currentLang);
    return this.callAPI._postAPI("/admin/get-term-condition-content", data, this.httpOptions);
  }

  patient_notification(data) {
    data.append('receiver_id', this.authService.currentUserValue.id);
    data.append('receiver_type', this.authService.currentUserValue.user_role.toLowerCase());
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/admin/get-all-notifications', data, this.httpOptions)
  }

  // Delete Medicines from Cart
  deleteMedicine(data) {
    data.append('user_id', this.authService.currentUserValue.id);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/remove-medicine-from-cart', data, this.httpOptions)
  }
  // View Prescroption
  view_prescription_list(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/store-prescription-request-list', data, this.httpOptions)
  }
  // Quotation Detail
  quotation_detail(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/quotation-detail', data, this.httpOptions)
  }

  // Access Prescroption
  access_prescription_list(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/prescription-access-request-list', data, this.httpOptions)
  }
  // Accept Prescroption
  access_prescription(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/prescription-access-accept-reject', data, this.httpOptions)
  }
  // Accept Prescroption
  prescription_accept(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/accept-quotation', data, this.httpOptions)
  }
  // Reject Prescroption
  prescription_reject(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/reject-quotation', data, this.httpOptions)
  }
  // Update Cart
  update_cart(data) {
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/update-cart', data, this.httpOptions)
  }
  // QR Code Scanner API
  QR_code_scanned(data) {
    data.append('login_id', this.authService.currentUserValue.id);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/scan-appointments-invoice', data, this.httpOptions)
  }
  //Promocode Offer List
  get_offer(data) {
    data.append("user_id", this.authService.currentUserValue.id);
    data.append("language", this.translate.currentLang);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    return this.callAPI._postAPI("/patient/active-offers", data, this.httpOptions);
  }
  //Promocode Offer List
  valid_promocode(data) {
    data.append("user_id", this.authService.currentUserValue.id);
    data.append("language", this.translate.currentLang);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    return this.callAPI._postAPI("/patient/promocode-validation", data, this.httpOptions);
  }
  // Platform Setting
  platform_setting(data) {
    data.append("user_id", this.authService.currentUserValue.id);
    data.append("language", this.translate.currentLang);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    return this.callAPI._postAPI("/patient/get-platform-settings", data, this.httpOptions);
  }
  // Patient Send Money request to withdrawal API
  request_send(data) {
    data.append('patient_id', this.authService.currentUserValue.id);
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/patient/send-withdrawal-request', data, this.httpOptions)
  }

  // Paypal Success
  payment_success(data) {
    data.append("user_id", this.authService.currentUserValue.id);
    data.append("language", this.translate.currentLang);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    return this.callAPI._postAPI("/patient/paypal/success", data, this.httpOptions);
  }
  // Paypal fail
  payment_fail(data) {
    data.append("user_id", this.authService.currentUserValue.id);
    data.append("language", this.translate.currentLang);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    return this.callAPI._postAPI("/patient/paypal/failed", data, this.httpOptions);
  }

  // MTN Payment
  mtn_pay_request(data) {
    data.append("user_id", this.authService.currentUserValue.id);
    data.append("language", this.translate.currentLang);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    return this.callAPI._postAPI("/mtn-pay-request", data, this.httpOptions);
  }
  // MTN Payment Status
  mtn_check_payment_status(data) {
    data.append("language", this.translate.currentLang);
    return this.callAPI._postAPI("/mtn-check-payment-status", data, this.httpOptions);
  }
  //  Appointment List
  lis_of_appointment(data) {
    data.append("user_id", this.authService.currentUserValue.id);
    data.append("language", this.translate.currentLang);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    return this.callAPI._postAPI('/emr/get-all-appointment', data, this.httpOptions)
  }
  // Prescription  List
  lis_of_prescription(data) {
    data.append("user_id", this.authService.currentUserValue.id);
    data.append("language", this.translate.currentLang);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    return this.callAPI._postAPI('/emr/get-all-prescription', data, this.httpOptions)
  }
  // Prescription Detail
  prescription_detail(data) {
    data.append("user_id", this.authService.currentUserValue.id);
    data.append("language", this.translate.currentLang);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    return this.callAPI._postAPI('/emr/get-prescription-info', data, this.httpOptions)
  }
  // Access Prescription list
  Access_Prescription_list(data) {
    data.append("user_id", this.authService.currentUserValue.id);
    data.append("language", this.translate.currentLang);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    return this.callAPI._postAPI('/emr/emr-access-request-list', data, this.httpOptions)
  }
  // Reject Request
  request_reject(data) {
    data.append("user_id", this.authService.currentUserValue.id);
    data.append("language", this.translate.currentLang);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    return this.callAPI._postAPI('/emr/emr-reject-request', data, this.httpOptions)
  }
  // accept Request
  request_accept(data) {
    data.append("user_id", this.authService.currentUserValue.id);
    data.append("language", this.translate.currentLang);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    return this.callAPI._postAPI('/emr/emr-accept-request', data, this.httpOptions)
  }
  //////////////////////////////Life Habbit///////////////////////
  create_habbit(data) {
    data.append("patient_id", this.authService.currentUserValue.id);
    data.append("language", this.translate.currentLang);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    return this.callAPI._postAPI('/patient/create-life-habit', data, this.httpOptions)
  }
  get_habbit(data) {
    data.append("patient_id", this.authService.currentUserValue.id);
    data.append("language", this.translate.currentLang);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    return this.callAPI._postAPI('/patient/get-life-habit', data, this.httpOptions)
  }
  update_habbit(data) {
    data.append("patient_id", this.authService.currentUserValue.id);
    data.append("language", this.translate.currentLang);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    return this.callAPI._postAPI('/patient/update-life-habit', data, this.httpOptions)
  }
  update_constent(data) {
    data.append("patient_id", this.authService.currentUserValue.id);
    data.append("language", this.translate.currentLang);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    return this.callAPI._postAPI('/patient/update-my-constants', data, this.httpOptions)
  }
  get_medical_file(data) {
    data.append("patient_id", this.authService.currentUserValue.id);
    data.append("language", this.translate.currentLang);
    data.append('user_role', this.authService.currentUserValue.user_role.toLowerCase());
    return this.callAPI._postAPI('/patient/get-patient-medical-file', data, this.httpOptions)
  }
  // Get Specialities Master
  getSpecialitiesMaster(data) {
    data.append('language', this.translate.currentLang);
    return this.callAPI._postAPI('/doctor/get-doctor-specialities', data, this.httpOptions)
  }
  //////////////////////////////Life Habbit End///////////////////////
}
